// =============================================
// COMPONENTE: MAINTENANCE NODE
// =============================================
// Arquivo: MaintenanceNode.tsx
// Descricao: No para operacoes de manutencao preventiva e corretiva
// =============================================

import React from 'react';
import { Handle, Position, NodeProps } from 'reactflow';
import { Settings } from 'lucide-react';
import ActionsBadge from './ActionsBadge';

const MaintenanceNode: React.FC<NodeProps> = ({ data, selected }) => {
  const {
    label,
    operation,
    maintenanceType,
    veiculo_id,
    descricao,
    prioridade,
    tipo_manutencao,
    description,
    actions
  } = data;

  const getOperationLabel = (op: string) => {
    const labels: Record<string, string> = {
      create: 'Criar',
      find: 'Buscar',
      update: 'Atualizar',
      list: 'Listar'
    };
    return labels[op] || op;
  };

  const getMaintenanceTypeLabel = (type: string) => {
    return type === 'corrective' ? 'Corretiva' : 'Preventiva';
  };

  const getPriorityColor = (priority: string) => {
    const colors: Record<string, string> = {
      'Baixa': '#22c55e',
      'Media': '#eab308',
      'Alta': '#f97316',
      'Urgente': '#ef4444'
    };
    return colors[priority] || '#6b7280';
  };

  return (
    <div className={`flow-node maintenance-node ${selected ? 'selected' : ''}`}>
      <Handle type="target" position={Position.Top} className="flow-handle" />

      <div className="node-header maintenance-header" style={{ backgroundColor: '#f97316' }}>
        <Settings className="node-icon" size={18} />
        <span className="node-title">{label || 'Manutencao'}</span>
      </div>

      <div className="node-body">
        {maintenanceType && (
          <div className="node-field">
            <span className="field-label">Tipo:</span>
            <span className="field-value">{getMaintenanceTypeLabel(maintenanceType)}</span>
          </div>
        )}
        {operation && (
          <div className="node-field">
            <span className="field-label">Operacao:</span>
            <span className="field-value">{getOperationLabel(operation)}</span>
          </div>
        )}
        {veiculo_id && (
          <div className="node-field">
            <span className="field-label">Veiculo:</span>
            <span className="field-value code">{veiculo_id}</span>
          </div>
        )}
        {tipo_manutencao && (
          <div className="node-field">
            <span className="field-label">Servico:</span>
            <span className="field-value">{tipo_manutencao}</span>
          </div>
        )}
        {prioridade && (
          <div className="node-field">
            <span className="field-label">Prioridade:</span>
            <span
              className="field-value priority-badge"
              style={{ color: getPriorityColor(prioridade) }}
            >
              {prioridade}
            </span>
          </div>
        )}
        {descricao && (
          <div className="node-description">{descricao}</div>
        )}
        {description && (
          <div className="node-description">{description}</div>
        )}
        <ActionsBadge actions={actions} />
      </div>

      <Handle type="source" position={Position.Bottom} className="flow-handle" />
    </div>
  );
};

export default MaintenanceNode;
